export const SET_ARTIFACTS = 'SET_ARTIFACTS';
export const SET_ANNOUNCEMENTS = 'SET_ANNOUNCEMENTS';
export const SET_ACCOUNT = 'SET_ACCOUNT';
export const SET_COMMUNICATION = 'SET_COMMUNICATION';
export const SET_NOTIFICATION = 'SET_NOTIFICATION'
export const USER_LOGGED_OUT_FROM_GOOGLE = 'opt_out_or_no_session';